

import {Request} from '@/api/request';
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch, nextTick,
} from "vue";
import {
    getInfoOrderOffer,
    getLibraryInfo, getMountingsCheckOutInfo,
    getOrderCarMountings,
    getOrderCarProject,
    postAddOrderOffer
} from "@/api/http";
import { Debounce } from "@/api/api";
import {dateformat} from "@/api/date" ;
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import {useRoute, useRouter} from 'vue-router'
import {validateInput, validateClass} from "@/assets/js/formRules";

type project = {
    id: number;
    project_type_pid: number;
    name: string;
};
type dialogSelect = {
    project_type_pid?: number;
    search?: string;
};
type order = {
    basicset_id: number;
    id: number;
    user_id: number;
    coupon_text: string;
    pay_type: number;
    payment: number;
    order: any;
    order_car: any;
    order_message: any;
    offer: any;
    last_order_id: string;
    next_order_id: string
};

const partsColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "配件分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 84,
    },
    {
        prop: "price",
        label: "价格",
        width: 84,
    },
    {
        prop: "stock",
        label: "库存",
        width: 84,
    },
];

const return_cash_plan = {
    return_cash_plan: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请选择返现方案"));
                }
            },
            trigger: "blur",
        },
    ],
};

const formRules = {
    type: [{required: true, message: '必填', trigger: 'change'}],
    supplier_id: [{required: true, message: '必填', trigger: 'change'}],
    date: [{required: true, message: '必填', trigger: 'change'}],
}


export default defineComponent({
    name: "createOutBill",
    components: {editList},
    setup() {
        const setTitle: any = inject("setTitle");
        const headClass = inject("headClass");
        const Router = useRouter();
        let searchKeyWords = ref(''),
            //配件搜索
            searchMountings = new Debounce().use(() => {
                getOrderCarMountings({search: searchKeyWords.value}).then((res: any) => {
                    partsTable.value = res?.content?.mountings_data?.list || [];
                });
            },500);
        let uid: any = 0,
            inputref = ref(null) as any,
            type: any = '',
            offer_data = ref([]) as any,
            dialog_show = reactive({
                parts: false,
                carcode: false
            } as any),
            is_save = ref(false),
            dialog_show_ = ref(""),
            dialogNavIndex = ref(0),
            dialog_search = ref('' as string),
            dialog_isload = ref(false),
            dialog_data = ref([] as Array<any>),
            detailData = reactive([1, 2, 4, 5, 6] as Array<any>),
            serviceForm = ref({
                name: "",
                price: null,
                return_cash_plan: null,
            }),
            partsForm = ref({
                ...serviceForm.value,
                encoding: null,
                specification: "",
                unit_id: null,
            }),
            is_detail = ref(false),
            partsFormNode = ref(null),
            partsTable = ref([]),
            dialogSelect = ref({} as dialogSelect),
            serviceTable = ref([]),
            form = ref({
                type: 0,
                takeaway: null,
                car_order_id: null,
                car_name: null,
                parts: [],
                branch_id: null,
                ordersn: null,
                desc: ""
            } as any),
            is_all = ref(false),
            serviceDialog = ref(false),
            supplierList = ref([] as any),
            orderDetail = ref({offer: [[], []]} as order),
            selectData: Array<project> = [],
            selectList = reactive({
                staff: [],
                branch: [],
                mountings_type_data: [],
                mountings_type_p_data: []
            }),
            is_load = ref(false),
            formRef = ref(null),
            PurchaseManList = ref([] as any),
            
            handleSelectionChange = (selection: Array<project>): void => {
                selectData = selection;
            },
            //选中配件列表的一条数据
            handleCurrentChange = (selection: any): void => {
                if (!selection) return
                for (const parts of form.value.parts) {
                    if (parts.mountings_id == selection.id) {
                        alert("您选择的配件已经在列表中了，请直接改数量");
                        return;
                    }
                }
                form.value.parts.push({
                    mountings_type_id: selection.id,
                    mountings_id: selection.id,
                    name: selection.name,
                    specification: selection.specification,
                    mountings_type_pname: selection.mountings_type_name,
                    mountings_brand_name: selection.mountings_brand_name,
                    unit: selection.mountings_unit_name,
                    unit_price: selection.ctock_price,
                    number: '0'
                })
                dialog_show_.value = ''
            },
            //验证表单数据
            checkFormData = (): boolean => {
                if (form.value.type == 0) {
                    if (!form.value.takeaway) {
                        alert('请选择领料人');
                        return false;
                    }
                    if (!form.value.car_name) {
                        alert('请选择维修车辆')
                        return false;
                    }
                    if (!form.value.branch_id) {
                        alert('请选择成本承担部门')
                        return false;
                    }
                } else if (form.value.type == 1) {
                    if (form.value.type == 1) {
                        if (!form.value.takeaway) {
                            alert('请选择领料人');
                            return false;
                        }
                        if (!form.value.branch_id) {
                            alert('请选择成本承担部门')
                            return false;
                        }
                    }
                }
                if (form.value.parts.length == 0) {
                    alert('请添加配件')
                    return false;
                } else {
                    for (const parts of form.value.parts) {
                        if (parts.number <= 0) {
                            alert('请输入数量')
                            return false;
                        }
                    }
                }
                return true
            },
            //提交
            _onsubmit = () => {
                if (!checkFormData()) {
                    return;
                }
                is_load.value = true;
                let url = '';
                let myData = {};
                
                if (is_save.value) {//useRoute().query.uid
                    //出库单修改
                    url = 'adminapi/Warehouse/ChangeDelivery';
                    myData = {...form.value, id: uid}
                } else {
                    //出库单新增
                    url = 'adminapi/Warehouse/CreateDelivery';
                    myData = form.value;
                }
                
                Request.axiosInstance({
                    url: url,
                    data: myData
                }).then((res: any) => {
                    is_load.value = false
                    res.status == 202 && Router.go(-1)
                })
            },
            //点击添加配件弹窗
            _editlist_add = () => {
                dialog_show_.value = 'parts'
            },
            getSummaries = (param: any) => {
            },
            //车牌号码搜索
            get_dialog_data = () => {
                
                dialog_isload.value = true
                if (dialog_show_.value == 'carcode') {
                    Request.axiosInstance({
                        url: 'adminapi/OrderCar/carcodeGetList',
                        data: {car_code: dialog_search.value}
                    }).then((res: any) => {
                        dialog_isload.value = false
                        dialog_data.value = res?.content?.list || []
                    })
                } else {
                    Request.axiosInstance({
                        url: 'adminapi/Warehouse/libraryList',
                        data: {type: 1, status: 1, search: dialog_search.value, library_type: '1'}
                    }).then((res: any) => {
                        dialog_isload.value = false
                        dialog_data.value = res?.content?.list || []
                    })
                }
                
                
            },
            //出库详情点击箭头自动添加到列表
            getMountingInfo = (item: any) => {
                for (const parts of form.value.parts) {
                    if (parts.mountings_id == item.mountings_id) {
                        alert("您选择的配件已经在列表中了，请直接改数量");
                        return;
                    }
                }
                form.value.parts.push({
                    order_num:item.order_num,
                    mountings_type_id: item.mountings_type_pid,
                    mountings_id: item.mountings_id,
                    name: item.name,
                    specification: item.specification,
                    mountings_type_pname: item.mountings_type_name,
                    mountings_brand_name: item.mountings_brand_name,
                    unit: item.mountings_unit_name,
                    unit_price: item.price,
                    number: item.quto_num
                })
            },
            //选中车牌
            _table_select_carcode = (selection: any) => {
                if (!selection) return
                if (dialog_show_.value == 'carcode') {
                    form.value['car_order_id'] = selection.id;
                    form.value['car_name'] = selection.car_code;
                    form.value['ordersn'] = selection.ordersn;
                    //选完车牌之后要自动添加关联车辆报价配件供选择，去配件报价那里也就是orderoffer表拿，已出库和未出库的都显示出来，
                    // 然后在去出入库记录表查询该订单已出库的配件
                    //入库是点添加的时候显示相应的配件
                    getMountingsCheckOutInfo({order_id: selection.id}).then((res: any) => {
                        if (res.status == 200) {
                            offer_data.value = [];
                            let sort = 1;
                            for (const item of selection.mountings_list) {
                                //const numInfo = res.content.list.find(v => v.mountings_id == item.mountings_id);
                                let totalInfo = {} as any;
                                for (const check of res.content.list) {
                                    if (check.mountings_id == item.mountings_id) {
                                        totalInfo = check;
                                    }
                                }
                                let can_use = 0;
                                if (item.num <= totalInfo.number-totalInfo.return_number) {
                                    can_use = 1;
                                }
                                offer_data.value.push({
                                    order_num:sort,
                                    name: item.mountings.name,
                                    mountings_id: item.mountings_id,
                                    encoding: item.mountings.encoding,
                                    specification: item.mountings.specification,
                                    is_temporary: item.mountings.is_temporary,
                                    mountings_type_pid: item.mountings.mountings_type_pid,
                                    mountings_type_p_name: totalInfo.mountings_type_p_name,
                                    mountings_brand_id: item.mountings.mountings_brand_id,
                                    mountings_brand_name: totalInfo.mountings_brand_name,
                                    unit_id: item.mountings.unit_id,
                                    unit_name: totalInfo.mountings_unit_name,
                                    quto_num: item.num,
                                    use_num: item.num,
                                    get_num: totalInfo.number,
                                    return_number: totalInfo.return_number,
                                    can_use: can_use,
                                    price: item.mountings.ctock_price
                                })
                                sort++;
                            }
                            ;
                        }
                    });
                } else if (dialog_show_.value == 'warehousing') {
                    form.value['ordersn'] = selection.record_code
                }
                
                dialog_show_.value = ''
            },
            //获取出库单详情
            getdetail = (id: number) => {
                //门店ID【当为总店时必传】
                let userinfo;
                let user_info = localStorage.getItem('user_info');
                if (user_info) {
                    userinfo = JSON.parse(user_info);
                }
                let data = {};
                if (userinfo.store_id == 0) {
                    data = {
                        store_id: 'store_id',
                        id
                    }
                } else {
                    data = {
                        id
                    }
                }
                getLibraryInfo(data).then((res: any) => {
                    if (res.status == 200) {
                        form.value.branch_id = res.content.info.branch_id;
                        form.value.takeaway = res.content.info.takeaway;
                        form.value.desc = res.content.info.desc;
                        form.value.type = res.content.info.type;
                        form.value.parts = res.content.info.parts_list;
                        form.value.car_order_id = res.content.info.car_order_id;
                        form.value.ordersn = res.content.info.ordersn;
                        form.value.car_name = res.content.info.car_name;
                    }
                });
            },
            //删除配件
            _defItem = (index: number) => {
                if (!confirm('是否确认操作？')) return
                form.value.parts.splice(index, 1)
            }
        
        watch(dialog_show_, (newdata: any, olddata: any) => {
            if (newdata == 'carcode' || newdata == 'warehousing') {
                dialog_search.value = "";
                nextTick(() => {
                    inputref.value.focus();
                });
                get_dialog_data();
            } else if (newdata == 'parts') {
                getOrderCarMountings({...dialogSelect.value,limit:10}).then((res: any) => {
                    partsTable.value = res?.content?.mountings_data?.list || [];
                    selectList.mountings_type_data = res?.content?.mountings_type || [];
                    selectList.mountings_type_p_data = res?.content?.mountings_type_p || [];
                });
            }
        });
        
        onMounted(() => {
            let title = ''
            is_load.value = true
            type = useRoute().query.my_type
            title = "出库单";
            setTitle(["仓库管理", title]);
            Request.axiosInstance({
                url: 'adminapi/OrderCar/constructors'
            }).then((res: any) => {
                selectList.staff = res?.content?.staff || []
                selectList.branch = res?.content?.branch || []
                is_load.value = false
            });
            let id: any = useRoute().query.uid;
            uid = useRoute().query.uid;
            if (id) {
                getdetail(id);
                is_save.value = true;
            }
        });
        
        return {
            dialog_show,
            dialogNavIndex,
            partsForm,
            partsFormNode,
            partsTable,
            dialogSelect,
            serviceForm,
            selectList,
            headClass,
            is_all,
            handleSelectionChange,
            handleCurrentChange,
            partsColumn,
            getOrderCarProject,
            serviceDialog,
            orderDetail,
            selectData,
            serviceTable,
            form,
            PurchaseManList,
            supplierList,
            is_load,
            _onsubmit,
            formRef,
            formRules,
            _editlist_add,
            type,
            is_detail,
            getSummaries,
            detailData,
            dialog_isload,
            dialog_data,
            dialog_search,
            get_dialog_data,
            _table_select_carcode,
            dialog_show_,
            _defItem,
            searchMountings,
            searchKeyWords,
            inputref,
            offer_data,
            getMountingInfo
        };
    },
});
